var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "select-wrap" }, [
      _c(
        "div",
        [
          _c("el-date-picker", {
            attrs: {
              "picker-options": _vm.pickerOptions,
              clearable: false,
              "unlink-panels": "",
              type: "daterange",
              format: "yyyy-MM-dd",
              "value-format": "yyyy-MM-dd",
              "range-separator": "-",
              "start-placeholder": "开始日期",
              "end-placeholder": "结束日期",
              size: "small"
            },
            on: { change: _vm.onChangeTime },
            model: {
              value: _vm.time,
              callback: function($$v) {
                _vm.time = $$v
              },
              expression: "time"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.getData }
            },
            [_vm._v("查询")]
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card-wrap" }, [
      _c("div", [
        _c("div", { staticClass: "card-title" }, [_vm._v("已发货金额")]),
        _vm._v(" "),
        _c("div", { staticClass: "card-content" }, [
          _c("span", { staticClass: "card-content-money" }, [_vm._v("￥")]),
          _vm._v(
            _vm._s(_vm.totalData.send_amount ? _vm.totalData.send_amount : 0)
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card-footer" }, [
          _vm._v("单数："),
          _c("span", { staticClass: "card-footer-money" }, [
            _vm._v(
              _vm._s(_vm.totalData.send_count ? _vm.totalData.send_count : 0)
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("div", { staticClass: "card-title" }, [_vm._v("退款金额")]),
        _vm._v(" "),
        _c("div", { staticClass: "card-content" }, [
          _c("span", { staticClass: "card-content-money" }, [_vm._v("￥")]),
          _vm._v(
            _vm._s(
              _vm.totalData.refund_amount ? _vm.totalData.refund_amount : 0
            )
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card-footer" }, [
          _vm._v("单数："),
          _c("span", { staticClass: "card-footer-money" }, [
            _vm._v(
              _vm._s(
                _vm.totalData.refund_count ? _vm.totalData.refund_count : 0
              )
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("div", { staticClass: "card-title" }, [_vm._v("实结金额")]),
        _vm._v(" "),
        _c("div", { staticClass: "card-content" }, [
          _c("span", { staticClass: "card-content-money" }, [_vm._v("￥")]),
          _vm._v(
            _vm._s(
              _vm.totalData.already_amount ? _vm.totalData.already_amount : 0
            )
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card-footer" }, [
          _vm._v("单数："),
          _c("span", { staticClass: "card-footer-money" }, [
            _vm._v(
              _vm._s(
                _vm.totalData.already_count ? _vm.totalData.already_count : 0
              )
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("div", { staticClass: "card-title" }, [_vm._v("未结金额")]),
        _vm._v(" "),
        _c("div", { staticClass: "card-content" }, [
          _c("span", { staticClass: "card-content-money" }, [_vm._v("￥")]),
          _vm._v(
            _vm._s(_vm.totalData.not_amount ? _vm.totalData.not_amount : 0)
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card-footer" }, [
          _vm._v("单数："),
          _c("span", { staticClass: "card-footer-money" }, [
            _vm._v(
              _vm._s(_vm.totalData.not_count ? _vm.totalData.not_count : 0)
            )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "summary-report-wrap" },
      [
        _c(
          "el-table",
          {
            staticStyle: { width: "100%" },
            attrs: {
              data: _vm.tableData,
              loading: _vm.loading,
              "row-key": function(row) {
                return row.created_time
              }
            },
            on: { "expand-change": _vm.expandChange }
          },
          [
            _c("el-table-column", {
              attrs: { type: "expand", width: "30" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: scope.row.loading,
                              expression: "scope.row.loading"
                            }
                          ]
                        },
                        [
                          _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { data: scope.row.list }
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  type: "index",
                                  label: "",
                                  width: "100"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "header",
                                      fn: function(pos) {
                                        return [
                                          _c(
                                            "el-select",
                                            {
                                              attrs: {
                                                value: scope.row.search,
                                                placeholder: "请选择",
                                                size: "mini"
                                              },
                                              on: {
                                                change: function(val) {
                                                  return _vm.searchDetailHandler(
                                                    val,
                                                    scope.row.created_time
                                                  )
                                                }
                                              }
                                            },
                                            _vm._l(_vm.plainOptions, function(
                                              item
                                            ) {
                                              return _c("el-option", {
                                                key: item.value,
                                                attrs: {
                                                  label: item.label,
                                                  value: item.value
                                                }
                                              })
                                            }),
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: { prop: "sku_name", label: "商品名称" }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "order_amount",
                                  label: "供货金额",
                                  width: "100"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "total_amount",
                                  label: "结算金额",
                                  width: "100"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "payment_bill_status_text",
                                  label: "状态",
                                  width: "120"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.filterType(
                                                  scope.row.order_type,
                                                  scope.row.order_status_text,
                                                  scope.row
                                                    .payment_bill_status_text
                                                ).status
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "payment_bill_status",
                                  label: "原因"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.filterType(
                                                  scope.row.order_type,
                                                  scope.row.order_status_text,
                                                  scope.row
                                                    .payment_bill_status_text
                                                ).reason
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: { label: "操作", width: "100" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: { type: "text" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.detailHandler(
                                                    scope.row.id
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                    查看\n                  "
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("el-pagination", {
                            staticStyle: { "text-align": "center" },
                            attrs: {
                              "current-page": scope.row.currentPage,
                              "page-size": 10,
                              layout: "total, prev, pager, next, jumper",
                              total: scope.row.totalCount
                            },
                            on: {
                              "current-change": function(val) {
                                return _vm.handleCurrentChangeChild(val, scope)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "created_time", label: "日期" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(scope.row.created_time) +
                          "\n        "
                      )
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "send_amount", label: "已发货金额" }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "refund_amount", label: "退款金额" }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "already_amount", label: "实结金额" }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "not_amount", label: "未结金额" }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("el-pagination", {
          attrs: {
            "current-page": _vm.page,
            "page-sizes": [10, 50, 100, 200],
            "page-size": _vm.pagesize,
            layout: "total, sizes, prev, pager, next, jumper",
            total: _vm.totalCount
          },
          on: {
            "size-change": _vm.handleSizeChange,
            "current-change": _vm.handleCurrentChange
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      [
        _c(
          "el-dialog",
          {
            attrs: {
              title: "订单详情",
              visible: _vm.centerDialogVisible,
              "append-to-body": "",
              width: "70%",
              center: ""
            },
            on: {
              "update:visible": function($event) {
                _vm.centerDialogVisible = $event
              }
            }
          },
          [
            _c("div", [
              _c("div", { staticClass: "dialog-content" }, [
                _c("div", [
                  _vm._v("类型：" + _vm._s(_vm.dialogData.order_type_text))
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v("供货成交价：" + _vm._s(_vm.dialogData.order_price))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "dialog-content" }, [
                _c("div", [
                  _vm._v("主订单号：" + _vm._s(_vm.dialogData.main_number))
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "数量：" +
                      _vm._s(
                        _vm._f("fixedNumber")(_vm.dialogData.order_quantity)
                      )
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "dialog-content" }, [
                _c("div", [
                  _vm._v("子订单号：" + _vm._s(_vm.dialogData.order_number))
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v("供货金额：" + _vm._s(_vm.dialogData.order_amount))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "dialog-content" }, [
                _c("div", [
                  _vm._v("售后单号：" + _vm._s(_vm.dialogData.as_number))
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "OMS单据状态：" + _vm._s(_vm.dialogData.order_status_text)
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "dialog-content" }, [
                _c("div", [
                  _vm._v("推送时间：" + _vm._s(_vm.dialogData.push_time))
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "核算确认时间：" +
                      _vm._s(_vm.dialogData.payment_bill_created_on)
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "dialog-content" }, [
                _c("div", [
                  _vm._v(
                    "供货时间/售后确认时间：" +
                      _vm._s(_vm.dialogData.supply_time)
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "预计结算时间：" + _vm._s(_vm.dialogData.expect_settle_date)
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "dialog-content" }, [
                _c("div", [
                  _vm._v(
                    "主单状态：" + _vm._s(_vm.dialogData.ap_order_status_text)
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "结算状态：" +
                      _vm._s(_vm.dialogData.payment_bill_status_text)
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "dialog-content" }, [
                _c("div", [_vm._v("单位：" + _vm._s(_vm.dialogData.unit))]),
                _vm._v(" "),
                _c("div", [
                  _vm._v("结算金额：" + _vm._s(_vm.dialogData.total_amount))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "dialog-content" }, [
                _c("div", [
                  _vm._v("锐锢编码：" + _vm._s(_vm.dialogData.sku_code))
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v("付款/扣款时间：" + _vm._s(_vm.dialogData.paid_on))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "dialog-content" }, [
                _c("div", [
                  _vm._v("商品名称：" + _vm._s(_vm.dialogData.sku_name))
                ]),
                _vm._v(" "),
                _c("div")
              ])
            ]),
            _vm._v(" "),
            _c("span", {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            })
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6523bdc3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6523bdc3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/report/SummaryReport.vue
// module id = null
// module chunks = 